const footerNp = {
  company: 'कम्पनी',
  description: 'ग्रामीण बजार: स्थानीय बजारहरूलाई डिजिटलमा जोड्ने एक पहल। सुरक्षित र सहज किनमेलको अनुभव।',
  links: {
    company: 'कम्पनी',
    business: 'व्यवसाय',
    support: 'सपोर्ट',
    about: 'हाम्रो बारेमा',
    career: 'क्यारियर',
    contact: 'सम्पर्क',
    help: 'साहाय्यता',
    becomeSeller: 'बेच्ने पार्टनर बन्नुहोस्',
    businessAccount: 'व्यवसायिक अकाउन्ट',
    marketplacePolicy: 'मार्केटप्लेस नीतिहरू',
    deliveryPolicy: 'डेलिभरी नीति',
    returnPolicy: 'रिटर्न नीति',
    privacyPolicy: 'गोपनीयता नीति'
  },
  contact: {
    heading: 'सम्पर्क',
    address: 'ढाका, बंगलादेश'
  },
  copyright: (year) => `© ${year} ग्रामीण बजार। सबै अधिकार सुरक्षित।`
};

export default footerNp;


